<template>
    <b-container fluid>
        <header-buttons
        ></header-buttons>
        <admin-requests-table
                @onShow="show">
        </admin-requests-table>
    </b-container>
</template>

<script>
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import AdminRequestsTable from "../components/AdminRequestsTable";
    import {mapActions} from 'vuex';

    export default {
        name: "AdminRequestsListView",
        components: {AdminRequestsTable, HeaderButtons},
        data() {
            return {

            }
        },
        methods: {
            ...mapActions({
                adminRequestsShow: 'adminRequestsShow',
            }),

            show: function (match) {
                this.adminRequestsShow(match)
                    .then((resp) => {
                        this.$router.push({name: 'admin.requests.details', params: {id: resp.id}});
                    }).catch(() => {
                    this.$bvToast.toast('Richiesta non trovata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>
